import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { ReferentialEntity } from '../../models/referential-entity';

export const FILTERS_MAGIC_BOX_ACTIONS = {
  SET_FILTERS_MAGIC_BOX: 'SET_FILTERS_MAGIC_BOX',
  SET_APPLY_TO_MAGIC_BOX_FILTERS: 'SET_APPLY_TO_MAGIC_BOX_FILTERS',
  REFRESH_MAGIC_BOX_FILTERS: 'REFRESH_MAGIC_BOX_FILTERS',
};

export interface FiltersMagicBoxStateInterface {
  id: number;
  Sport: ReferentialEntity;
  Competition: ReferentialEntity;
  Event: ReferentialEntity;
  Leg: ReferentialEntity;
  Category: ReferentialEntity;
  InfoSupp: ReferentialEntity;
  Broadcasting: ReferentialEntity;
  for: number;
  applyTo: string[];
  refresh: boolean;
  showDeleted: boolean;
  isNonSportiveClassif: boolean;
}

@Injectable()
export class FiltersMagicBoxActions {

  constructor(private store: Store<FiltersMagicBoxStateInterface>) { }

  setFilters(filters: FiltersMagicBoxStateInterface) {
    this.store.dispatch({ type: FILTERS_MAGIC_BOX_ACTIONS.SET_FILTERS_MAGIC_BOX, payload: filters });
  }

  setApplyTo(applyTo: string[]) {
    this.store.dispatch({ type: FILTERS_MAGIC_BOX_ACTIONS.SET_APPLY_TO_MAGIC_BOX_FILTERS, payload: applyTo });
  }

  refresh() {
    this.store.dispatch({ type: FILTERS_MAGIC_BOX_ACTIONS.REFRESH_MAGIC_BOX_FILTERS });
  }
}



// WEBPACK FOOTER //
// ./src/app/store/actions/filters-magic-box.actions.ts